import request from 'axios';

export const FETCH_LANGUAGES = 'crowdspring/profile/FETCH_LANGUAGES';
export const FETCH_LANGUAGES_REQUEST = 'crowdspring/profile/FETCH_LANGUAGES_REQUEST';
export const FETCH_LANGUAGES_FAILURE = 'crowdspring/profile/FETCH_LANGUAGES_FAILURE';
export const FETCH_LANGUAGES_SUCCESS = 'crowdspring/profile/FETCH_LANGUAGES_SUCCESS';

export function parseLanguages(response) {
  const list = response.data.map((language) => ({ label: language[1], value: language[0] }));
  const abbreviations = response.data.reduce((mem, language) => {
    mem[language[0]] = language[1];
    return mem
  }, {});

  return {
    ...response,
    data: {
      list,
      abbreviations,
    }
  };
}

export const fetchLanguagesIfNeeded = () => (dispatch, getState) => {
  /* languages already fetched */
  if (getState().profile.languages.data) {
    return Promise.resolve();
  }

  const opts = {
    method: 'get',
    url: '/api/v1/users/languages/',
  };

  return dispatch({
    type: FETCH_LANGUAGES,
    promise: request(opts).then(parseLanguages),
  });
}

const INITIAL_STATE = {
  data: null,
  isLoading: true,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_LANGUAGES:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_LANGUAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./profile/ducks/languages.js